// Functional parity helpers split from App.js; keep UI flow in App.js.
export const LEGACY_DEFAULT_PROJECT_ID = "main_project";
export const TOOL_PAGES = [
  {
    id: "vehicle-km-driver",
    label: "Araç-Km-Sürücü",
    description: "Araç, kilometre ve sürücü kayıtlarını bu sayfada yöneteceğiz.",
  },
  {
    id: "fuel",
    label: "Yakıt",
    description: "Yakıt girişleri ve yakıt takibini bu sayfada yöneteceğiz.",
  },
];

export const PACKAGING_PAGE = {
  id: "packaging",
  label: "Paketleme",
  description: "Pafta bazlı paket ve grup kayıtlarını proje kapsamında yöneteceğiz.",
};

function normalizeIdentityToken(value) {
  return String(value || "").trim().toLocaleLowerCase("tr-TR");
}

export function resolveAutoTeamIdForUser(teams, user) {
  if (!Array.isArray(teams) || teams.length === 0 || !user) return null;

  const identityTokens = [
    user.name,
    user.displayName,
    user.username,
    user.email,
  ]
    .map(normalizeIdentityToken)
    .filter(Boolean);

  if (identityTokens.length === 0) return null;

  const matchingTeams = teams.filter((team) =>
    Array.isArray(team?.members) &&
    team.members.some((member) =>
      identityTokens.includes(normalizeIdentityToken(member))
    )
  );

  if (matchingTeams.length !== 1) return null;
  return String(matchingTeams[0].id);
}

export function isAuthError(error) {
  const status = error?.response?.status;
  return status === 401 || status === 403;
}

export function readSessionValue(key) {
  const localValue = localStorage.getItem(key);
  if (localValue != null) return localValue;
  return sessionStorage.getItem(key);
}

export function writeSessionValue(key, value, remember) {
  if (value == null) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
    return;
  }

  if (remember) {
    localStorage.setItem(key, value);
    sessionStorage.removeItem(key);
    return;
  }

  sessionStorage.setItem(key, value);
  localStorage.removeItem(key);
}

export function clearSessionValue(key) {
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
}

export function getGlobalRoleLabel(user, projectId) {
  if (!user) return "";
  if (user.role === "superadmin" || user.projectRoles?.ALL === "superadmin") {
    return "Süper Admin";
  }

  const scopedRole = user.projectRoles?.[projectId] || user.role;
  if (scopedRole === "project_admin") {
    return "Proje Yöneticisi";
  }

  return "Kullanıcı";
}

export function parseCoordinateSearch(xValue, yValue) {
  const xRaw = String(xValue || "").trim();
  const yRaw = String(yValue || "").trim();
  if (!xRaw || !yRaw) {
    return { error: "X ve Y koordinatlarını girin." };
  }

  const parseCoordinatePart = (value) => {
    const normalized = String(value)
      .replace(/[°'"’′″]/g, " ")
      .replace(/\s+/g, "")
      .replace(",", ".");
    return Number.parseFloat(normalized);
  };

  const lng = parseCoordinatePart(xRaw);
  const lat = parseCoordinatePart(yRaw);

  if (!Number.isFinite(lng) || !Number.isFinite(lat)) {
    return { error: "Koordinat okunamadı." };
  }

  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    return { error: "X -180/180, Y -90/90 aralığında olmalı." };
  }

  return {
    coordinate: {
      lat: Number(lat.toFixed(6)),
      lng: Number(lng.toFixed(6)),
    },
  };
}
